import React, { useState } from "react";
import { connect } from "react-redux";
import i18n from "i18next";
import { analyzeWorkflow } from "../../workflow/FlowViewer/analyzeWorkflow";
import SceneCard from "../../workflow/FlowViewer/SceneCard";
import StoryboardView from "../../workflow/FlowViewer/StoryboardView";
import KnollingView from "../../timeline/IdeaTimeline/components/KnollingView";
import EmptyState from "./FlowViewerTab/EmptyState";
import { planTrainingBaseline } from "../../workflow/planTrainingBaseline";
import "./FlowViewerTab.scss";

const MODES = ["all", "scene", "storyboard"];

function FlowViewerTab({
  navItemsById,
  boxesById,
  pluginToolbarsById,
  viewToolbarsById,
  currentSceneId,
}) {
  // Scene titles live in viewToolbarsById[sceneId].viewName.
  const titleOf = (sceneId) => {
    const vt = viewToolbarsById && viewToolbarsById[sceneId];
    const nav = navItemsById && navItemsById[sceneId];
    return (vt && vt.viewName) || (nav && (nav.title || nav.name)) || sceneId;
  };
  const [mode, setMode] = useState("all");
  const plan = planTrainingBaseline(navItemsById, boxesById, pluginToolbarsById);
  const everySectionEmpty =
    plan.stats.sections > 0 && plan.stats.sectionsNeedingWorkflow === plan.stats.sections;
  if (everySectionEmpty) {
    return <EmptyState />;
  }
  // Treat anything with a children[] array as a workflow container: real
  // sections (type:"section") AND, for trainings authored without sections,
  // the course-root navItem (id:0, type:""). Otherwise the canvas is empty
  // for any flat training.
  let sections = Object.values(navItemsById).filter((n) => n && n.type === "section");
  if (sections.length === 0) {
    sections = Object.values(navItemsById).filter(
      (n) => n && Array.isArray(n.children) && n.children.length > 0
    );
  }
  const analysis = analyzeWorkflow(navItemsById, sections);

  return (
    <div className="flow-viewer-tab">
      <div className="flow-viewer-tab__toggle">
        {MODES.map((m) => (
          <button
            key={m}
            type="button"
            className={
              mode === m ? "flow-viewer-tab__toggle-btn--on" : "flow-viewer-tab__toggle-btn"
            }
            onClick={() => setMode(m)}
          >
            {i18n.t(`FlowViewer.mode.${m}`, {
              defaultValue: m === "all" ? "Show All" : m === "scene" ? "Show Scene" : "Storyboard",
            })}
          </button>
        ))}
      </div>
      <div className="flow-viewer-tab__body">
        {mode === "all" && (
          <div data-testid="flow-viewer-tab__all" className="flow-viewer-tab__all">
            {analysis.scenesByOrder.map((sceneId) => {
              const scene = navItemsById[sceneId];
              const stats = analysis.perScene[sceneId] || {
                reads: [],
                writes: [],
                outboundJumps: [],
              };
              return (
                <SceneCard
                  key={sceneId}
                  scene={scene}
                  title={titleOf(sceneId)}
                  reads={stats.reads}
                  writes={stats.writes}
                  outbound={stats.outboundJumps}
                  onJump={() => {}}
                />
              );
            })}
          </div>
        )}
        {mode === "scene" && (
          <div data-testid="flow-viewer-tab__scene">
            <KnollingView
              embedded
              navItems={navItemsById}
              boxes={boxesById}
              pluginToolbars={pluginToolbarsById}
              navItemSelected={currentSceneId}
              onClose={() => {}}
              onNavigateToScene={() => {}}
            />
          </div>
        )}
        {mode === "storyboard" && (
          <div data-testid="flow-viewer-tab__storyboard">
            <StoryboardView
              scenes={analysis.scenesByOrder}
              perScene={analysis.perScene}
              navItemsById={navItemsById}
              boxesById={boxesById}
              pluginToolbarsById={pluginToolbarsById}
              viewToolbarsById={viewToolbarsById}
              onJump={() => {}}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const present = (state.undoGroup && state.undoGroup.present) || {};
  return {
    navItemsById: present.navItemsById || {},
    boxesById: present.boxesById || {},
    pluginToolbarsById: present.pluginToolbarsById || {},
    viewToolbarsById: present.viewToolbarsById || {},
    currentSceneId: present.navItemSelected,
  };
};
export default connect(mapStateToProps)(FlowViewerTab);
